import F from "./ghl-ui.es1224.js";
import { createTheme as L } from "./ghl-ui.es901.js";
import y from "./ghl-ui.es1192.js";
import z from "./ghl-ui.es1200.js";
import { changeColor as o } from "./ghl-ui.es936.js";
const T = (d) => {
  const {
    borderRadius: c,
    textColor2: p,
    textColorDisabled: s,
    inputColor: i,
    inputColorDisabled: b,
    primaryColor: r,
    primaryColorHover: a,
    warningColor: e,
    warningColorHover: n,
    errorColor: l,
    errorColorHover: t,
    borderColor: h,
    iconColor: x,
    iconColorDisabled: C,
    clearColor: g,
    clearColorHover: m,
    clearColorPressed: v,
    placeholderColor: $,
    placeholderColorDisabled: S,
    fontSizeTiny: u,
    fontSizeSmall: w,
    fontSizeMedium: f,
    fontSizeLarge: H,
    heightTiny: A,
    heightSmall: E,
    heightMedium: W,
    heightLarge: D
  } = d;
  return Object.assign(Object.assign({}, F), {
    fontSizeTiny: u,
    fontSizeSmall: w,
    fontSizeMedium: f,
    fontSizeLarge: H,
    heightTiny: A,
    heightSmall: E,
    heightMedium: W,
    heightLarge: D,
    borderRadius: c,
    // default
    textColor: p,
    textColorDisabled: s,
    placeholderColor: $,
    placeholderColorDisabled: S,
    color: i,
    colorDisabled: b,
    colorActive: i,
    border: `1px solid ${h}`,
    borderHover: `1px solid ${a}`,
    borderActive: `1px solid ${r}`,
    borderFocus: `1px solid ${a}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${o(r, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${o(r, {
      alpha: 0.2
    })}`,
    caretColor: r,
    arrowColor: x,
    arrowColorDisabled: C,
    loadingColor: r,
    // warning
    borderWarning: `1px solid ${e}`,
    borderHoverWarning: `1px solid ${n}`,
    borderActiveWarning: `1px solid ${e}`,
    borderFocusWarning: `1px solid ${n}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${o(e, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${o(e, {
      alpha: 0.2
    })}`,
    colorActiveWarning: i,
    caretColorWarning: e,
    // error
    borderError: `1px solid ${l}`,
    borderHoverError: `1px solid ${t}`,
    borderActiveError: `1px solid ${l}`,
    borderFocusError: `1px solid ${t}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${o(l, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${o(l, {
      alpha: 0.2
    })}`,
    colorActiveError: i,
    caretColorError: l,
    clearColor: g,
    clearColorHover: m,
    clearColorPressed: v
  });
}, j = L({
  name: "InternalSelection",
  common: y,
  peers: {
    Popover: z
  },
  self: T
}), V = j;
export {
  V as default
};
